<div class="rounded-2xl bg-white p-10">
  @if (step() == 1) {
    <app-personal-info (saved)="step.set(2)"></app-personal-info>
  } @else if (step() == 2) {
    <app-upload-images (saved)="step.set(3)" (onBack)="step.set(1)"></app-upload-images>
  } @else if (step() == 3) {
    <app-upload-extra-images (saved)="step.set(4)" (onBack)="step.set(2)"></app-upload-extra-images>
  } @else  if (step() == 4) {
    <app-habits (saved)="step.set(5)" (onBack)="step.set(3)"></app-habits>
  } @else  if (step() == 5) {
    <app-residency-data (saved)="step.set(6)" (onBack)="step.set(4)"></app-residency-data>
  } @else if (step() == 7) {
    <app-profile-completed></app-profile-completed>
  } @else if (step() == 6) {
    <app-verify-phone (saved)="step.set(7)"></app-verify-phone>
  }
</div>
